import { GEOMETRY_TOLERANCES } from "../../config/tolerances";

/**
 * 2D Vector & Trigonometric Math Utilities
 */

export function dotProduct(v1, v2) {
  return v1.x * v2.x + v1.y * v2.y;
}

export function subtractVectors(v1, v2) {
  return { x: v1.x - v2.x, y: v1.y - v2.y };
}

export function addVectors(v1, v2) {
  return { x: v1.x + v2.x, y: v1.y + v2.y };
}

export function scaleVector(v, scalar) {
  return { x: v.x * scalar, y: v.y * scalar };
}

export function normalizeVector(v) {
  const len = Math.sqrt(v.x * v.x + v.y * v.y);
  if (len < GEOMETRY_TOLERANCES.CALCULATION_EPSILON) return { x: 0, y: 0 };
  return { x: v.x / len, y: v.y / len };
}

export function perpendicularVector(v) {
  return { x: -v.y, y: v.x };
}

export function distance(p1, p2) {
  const dx = p1.x - p2.x;
  const dy = p1.y - p2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

export function rotatePoint(point, center, angleDegrees) {
  const angleRadians = (angleDegrees * Math.PI) / 180;
  const cos = Math.cos(angleRadians);
  const sin = Math.sin(angleRadians);

  const translatedX = point.x - center.x;
  const translatedY = point.y - center.y;

  return {
    x: center.x + (translatedX * cos - translatedY * sin),
    y: center.y + (translatedX * sin + translatedY * cos),
  };
}

export function pointsAreEqual(a, b, epsilon = GEOMETRY_TOLERANCES.POINT_SNAP_EPSILON) {
  return Math.abs(a.x - b.x) < epsilon && Math.abs(a.y - b.y) < epsilon;
}
